import Price from '../../ui/price'
import { makeNumbersFarsi } from '../../utils/farsi'
import { addThousandsSeparator } from '../../utils/format'

export const InvoiceSummary = ({ order, cart }: any) => {
  let item = order || cart
  if (!item.items || item.items.length === 0) {
    return null
  }

  let isCartPaymentDone = item.status !== 'checkout'
  let totalLabel = 'قابل پرداخت:'
  if (isCartPaymentDone) {
    totalLabel = 'مبلغ پرداختی:'
  }

  const formatPrice = (value: number) => {
    const priceStr = value.toString().substring(0, value.toString().length - 1)
    return makeNumbersFarsi(addThousandsSeparator(priceStr))
  }

  // Check if item has discount information
  const hasDiscounts =
    item.appliedDiscounts &&
    item.appliedDiscounts.length > 0 &&
    item.totalDiscountAmount > 0

  return (
    <div className='flex flex-col items-center'>
      <section className='total w-full'>
        <section className='flex items-center justify-between my-4 w-full'>
          <strong className='ml-4'>جمع کل:</strong>
          <Price
            value={item.subTotal}
            currencyCode={item.currencyCode}
            alternativeCurrencyCode={true}
          />
        </section>

        {/* Display individual discounts */}
        {hasDiscounts && (
          <div className='border-t pt-3 mb-3' style={{ borderColor: 'var(--border-color)' }}>
            {item.appliedDiscounts.map((discount: any, index: number) => (
              <section
                key={discount.couponId || index}
                className='flex items-center justify-between my-2 text-sm'
                style={{ color: '#10b981' }}
              >
                <div className='ml-4 flex items-center'>
                  <span className='font-semibold'>
                    {discount.code ? `تخفیف (${discount.code})` : 'تخفیف خودکار'}:
                  </span>
                </div>
                <span className='font-semibold'>
                  - {formatPrice(discount.discountAmount)} تومان
                </span>
              </section>
            ))}

            {/* Total discount */}
            <section
              className='flex items-center justify-between my-3 py-2 border-t'
              style={{
                color: '#10b981',
                borderColor: 'var(--border-color)',
              }}
            >
              <strong className='ml-4'>مجموع تخفیف:</strong>
              <strong>- {formatPrice(item.totalDiscountAmount)} تومان</strong>
            </section>
          </div>
        )}

        <section className='flex items-center justify-between my-4'>
          <strong className='ml-4'>هزینه ارسال:</strong>
          <Price
            value={item.shippingPrice}
            currencyCode={item.currencyCode}
            alternativeCurrencyCode={true}
          />
        </section>

        <section
          className='flex items-center justify-between my-4 text-lg font-bold pt-3 border-t'
          style={{ borderColor: 'var(--border-color)' }}
        >
          <strong className='ml-4'>{totalLabel}</strong>
          <Price
            value={item.total}
            currencyCode={item.currencyCode}
            alternativeCurrencyCode={true}
          />
        </section>
      </section>
    </div>
  )
}
